/* eslint-disable prettier/prettier */
function transformArrayDynamic(arr) {
  const result = {};

  arr.forEach((item) => {
    const key = item?.name;
    const translations = {};

    function collectTranslations(obj) {
      Object.keys(obj).forEach((langKey) => {
        if (langKey !== "name") {
          const valueArray = obj[langKey];
          if (Array.isArray(valueArray) && valueArray.length > 0) {
            const firstItem = valueArray[0];

            // Save the translation if there's a name
            if (firstItem.name) {
              translations[langKey] = firstItem.name;
            }

            // Recursively collect deeper translations
            collectTranslations(firstItem);
          }
        }
      });
    }

    collectTranslations(item);
    result[key] = translations;
  });

  return result;
}

export const appTranslation = async () => {
  try {
    const translationUrl =
      "https://resources.wizztech.us/static/wizztech.json";
    if (translationUrl) {
      const data1 = await fetch(translationUrl);
      const data2 = await data1.json();
      const formattedData = transformArrayDynamic(data2["translate-key"]);
      
      return formattedData;
    } else {
      console.warn(`No translation URL found for domain: ${translationUrl}`);
    }
  } catch (error) {
    console.error("Error in appTranslation:", error);
  }
};
